module.exports = __webpack_public_path__ + "static/standard-chartered-028dcdb6f0287f4149811c1dbdd2ae55.png";